import { parseToItems } from 'utils/parseToItems';

import useTranslation from 'components/fields/ApplicationSelectPanelField/hooks/useTranslation';

import useApplications from 'hooks/useApplications';
import useSelectPanelField from 'hooks/useSelectPanelField';

import { DEFAULT_PAGE_SIZE } from './constants';
import type { ApplicationResponse } from './types';

const useData = () => {
    const { fetch, isLoading, reset } = useApplications();
    const { NO_APPLICATIONS_FOUND } = useTranslation();

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<ApplicationResponse>({
            fetchFn: fetch,
            noItemsFoundText: NO_APPLICATIONS_FOUND,
            pageSize: DEFAULT_PAGE_SIZE,
            parseFn: parseToItems,
            resetFn: reset
        });

    return {
        applicationItems: items,
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage
    };
};

export default useData;
